import React from 'react';
import AutorenewIcon from '@material-ui/icons/Autorenew';

export const Loading = () => {
    return (
        <div className="col-12 text-center">
            <AutorenewIcon className="fa-pulse fa-fw"/>
            <p>Loading . . .</p>
        </div>
    );
};